'use client';

import { c as _c } from "react/compiler-runtime";
import type { VerticalScrollbar } from 'src/types/scrollbars';
import type React from 'react';
import { styled } from '@mui/material/styles';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { shouldForwardProp } from 'src/components/Particles/Particles';
import { scrollbarCustomProps } from 'src/components/Particles/Scrollbars';
interface ReportWrapperProps {
  children?: React.ReactNode;
  className?: string;
}
const Wrapper = styled(FlexColumn, shouldForwardProp([...scrollbarCustomProps]))<ReportWrapperProps & VerticalScrollbar>(({
  theme
}) => ({
  padding: theme.sizes.spacing['09'],
  flexGrow: 1,
  minHeight: 0,
  backgroundColor: theme.colors.surface.secondary,
  overflowX: 'hidden',
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  width: '100%'
}));
const ReportWrapper: React.FC<ReportWrapperProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Wrapper withScroll={true} vertical={true}>{children}</Wrapper>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ReportWrapper;
export type { ReportWrapperProps };